import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_VOID } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/invincible.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/invincible-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/invincible-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/invincible-extreme.circles.json' with { type: 'json' };

export const INVINCIBLE_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'invincible',
  baseTitle: "Invincible",
  description: "DEAF KEV's 174 BPM hands-up DnB classic. The OG NCS dance banger, top-tier cube challenge.",
  difficulty: 5,
  palette: PALETTE_VOID,
  attribution: "\"Invincible\" by DEAF KEV [NCS Release] - https://ncs.io/invincible",
  mapper: "nik_k",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    hard: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    extreme: { bpm: 203, offsetMs: 0, totalBeats: 206 },
  },
});
